import PropTypes from 'prop-types';
import "../../config.js";
import { CssBaseline } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import SvgIcon from '@mui/material/SvgIcon';
import PersonIcon from '@mui/icons-material/Person';
import BuildIcon from '@mui/icons-material/Build';
import AppMgrTool from '../mgr/AppMgrTool.js';
import AppMainMy from './AppMainMy.js';

function HomeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}

const AppMain = (props) => {

  return (
    <div>
      <CssBaseline />
      
      <div style={{ display: (props.datasource.appMainPage === 'home') ? 'block' : 'none' }}>
        <AppMgrTool />
      </div>

      <div style={{ display: (props.datasource.appMainPage === 'my') ? 'block' : 'none' }}>
        <AppMainMy />
      </div>

      <Paper elevation={3} style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <BottomNavigation
          showLabels
          value={props.datasource.appMainPage}
          onChange={(event, newValue) => {
            props.datasource.appMainPageCreate(newValue);
          }}
          style={{ background: global.constants.const_color_bg }}
        >
          <BottomNavigationAction label="首页" value="home" icon={<HomeIcon />} sx={{ color: props.datasource.appMainPage === 'home' ? global.constants.const_color_icon : global.constants.const_color_icon_unactive }} />
          {/* <BottomNavigationAction label="全国" value="build" icon={<BuildIcon />} sx={{ color: props.datasource.appMainPage === 'build' ? global.constants.const_color_icon : global.constants.const_color_icon_unactive }} />
          <BottomNavigationAction label="历史" value="his" icon={<HistoryIcon />} sx={{ color: props.datasource.appMainPage === 'his' ? global.constants.const_color_icon : global.constants.const_color_icon_unactive }} /> */}
          <BottomNavigationAction label="我的" value="my" icon={<PersonIcon />} sx={{ color: props.datasource.appMainPage === 'my' ? global.constants.const_color_icon : global.constants.const_color_icon_unactive }} />
        </BottomNavigation>
      </Paper>

    </div>
  );
}

AppMain.propTypes = {
  appMainPage: PropTypes.string,
  appMainPageCreate: PropTypes.func,
}
export default (datasource) => <AppMain datasource={datasource} />;

